/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { ButtonComponent, iconVariants, TooltipDirective } from '@ods/system';
import { VariantProps } from 'class-variance-authority';

type IconVariants = VariantProps<typeof iconVariants>;

@Component({
  selector: 'odc-download-button',
  imports: [ButtonComponent, TooltipDirective],
  template: `<ods-button
    [dataTestId]="dataTestId"
    icon="save"
    [iconConfig]="{ fill: 'text', size: 'small' }"
    variant="ghost"
    size="fit"
    spinnerSize="small"
    [isLoading]="isLoading"
    [disabled]="disabled"
    [tooltip]="tooltipText"
    tooltipAriaType="aria-label"
    (clicked)="clicked.emit()"
  />`,
})
export class DownloadButtonComponent {
  @Input({ required: true }) dataTestId: string;
  @Input() tooltipText: string = '';
  @Input() disabled: boolean = false;
  @Input() set stateResource(resource: StateResource<Resource>) {
    this.isLoading = resource.loading || resource.reload;
  }

  @Output() public clicked: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  isLoading: boolean = false;
}
